import { useAppBranding } from "@/hooks/use-app-branding";
import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  imgClassName?: string;
  /** How much to scale the inner image to crop the baked-in white padding */
  zoom?: number;
}

/**
 * Shared brand logo with a hard UI-level crop to eliminate the
 * white padding baked into the source asset. Used wherever the
 * WhisprAI mark appears to guarantee identical rendering.
 */
export function BrandLogo({ className, imgClassName, zoom = 1.8 }: BrandLogoProps) {
  const branding = useAppBranding();
  const src = branding.app_logo_url || "/app-logo.png";

  return (
    <div
      className={cn(
        "relative flex items-center justify-center overflow-hidden bg-transparent",
        className
      )}
      style={{
        maskImage: "radial-gradient(circle at center, black 52%, transparent 78%)",
        WebkitMaskImage: "radial-gradient(circle at center, black 52%, transparent 78%)",
      }}
    >
      <img
        src={src}
        alt={branding.app_name}
        className={cn(
          "h-full w-full object-cover bg-transparent drop-shadow-[0_4px_20px_hsl(var(--primary)/0.35)]",
          imgClassName
        )}
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: "center",
          mixBlendMode: "screen",
        }}
      />
    </div>
  );
}
